import { render, staticRenderFns } from "./FormsListComponent.vue?vue&type=template&id=0f9353c5&"
import script from "./FormsListComponent.vue?vue&type=script&lang=js&"
export * from "./FormsListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports